import React from 'react';


class DeconThoughtIntroduction extends React.PureComponent{
    _next = () => {
        return {
            go:true,
            value:{
                
            }
        }
    };
    render(): React.ReactNode {
        return (
            <div className="w-full h-full flex px-4  py-6 flex-col overflow-scroll action_container pb-40">
                    <span className="font-quick text-text text-[16px] leading-[20px] flex font-semibold">Deconstructing your Thoughts</span>
                    <img src='https://images.unsplash.com/photo-1679563559367-6452affe2705?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2101&q=80' className='object-cover w-full h-40 mt-4 mb-4'/>
                    <span className='font-quick text-title text-[13px] leading-[16px] font-medium'>Great work on deconstructing how you feel. We will now move on to deconstructing how you think about your Circumstance.</span>
            </div>
        )
    }
}


export default DeconThoughtIntroduction;